<template>
  <div>
    <page-title icon="fa fa-shopping-cart" main="Promoções" sub="Produtos da Campanha" :help="true" titleHelp="Ajuda - Ano Safra" content="Nesta página temos um Dashboard Geral"/>
    <card>
      <div slot="header">
        <span>Produtos da Campanha </span>
      </div>
      <div class="row">
        <div class="col-md-10">
          <base-input
            label="Produtos"
          >
            <multiselect
              v-model="product"
              :options="products"
              placeholder="Selecionar Produto"
              label="description"
              track-by="id"
              :select-label="''"
              :selected-label="'Selecionado'"
              :deselect-label="''"
            />
          </base-input>
        </div>
        <div class="col-md-2">
          <div style="margin-top: 15%">
            <base-button 
              icon 
              type="primary" 
              v-on:click="associate"
            >
              <span class="btn-inner--icon">
                <i class="fa fa-plus"></i>
              </span>
              <span class="btn-inner--text">Adicionar</span>
            </base-button>
          </div>
        </div>
      </div>
      <el-table
        class="table-responsive table-striped clickable-rows"
        header-row-class-name="thead-light"
        :data="campaign_products"
        ref="products"
      >
        <el-table-column 
          label="Código" 
          prop="code" 
          sortable
        />
        <el-table-column 
          label="Nome" 
          prop="description" 
          sortable
        />
        <el-table-column 
          label="Marca" 
          prop="brand" 
          sortable
        />
        <el-table-column 
          label="Ações" 
          width="120" 
          prop="acoes" 
          v-slot="{row}">
          <div class="row">
            <el-dropdown trigger="hover" class="dropdown" style="cursor: pointer;">
              <span class="btn btn-sm btn-icon-only text-success">
                <i class="fas fa-ellipsis-v mt-2"></i>
              </span>
              <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                <a class="dropdown-item" href="#" @click="desassociate(row)">Excluir</a>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-table-column>
      </el-table>
      <div slot="footer" class="py-4 d-flex justify-content-end">
        <base-pagination
          v-on:input="changePage"
          v-model="paginated_data['current']"
          :total="paginated_data['count']"
          :perPage="paginated_data['per_page']"
        ></base-pagination>
      </div>
    </card>
  </div>
</template>
<script>
import Vue from "vue";
import { Select, Option } from 'element-ui'
import { Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown 
} from "element-ui";
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import { ValidationProvider, extend } from "vee-validate";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";


export default {
  name: "app",
  components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      PageTitle,
      Multiselect,
      ValidationProvider,
      flatPicker,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      modals: {
        modal0: false
      },
      products: [], 
      campaign_products: [],
      product: {},
      campaign: {},
      filter: {},
      errors: [],
      // flag de verificação se foi pesquisado algo
      filtered: false,
      paginated_data: [],
      formData: {},
    }
  },
  created() {
    this.setStaticData();
    this.setData();
    // this.products = template_products;
  },
  methods: {
    setError(error, text) {
      this.error =
        (error.response && error.response.data && error.response.data.error) ||
        text;
    },
    setData(q, page) {
      //  Adicionando valores default a query e ao número da página se não definidos
      // console.log('antes');
      // console.log(q);
      if (typeof page === "undefined") page = 1;
      if (typeof q === "undefined" || this.emptyFilter) q = null;
    
      // console.log('depois');
      // console.log(q);

      this.$http.secured
        .get(`/api/v1/campaigns/${this.$route.params.campaign_id}/products`, {
          params: {
            campaign_id: this.$route.params.campaign_id,
            page: page,
            q: q
          }
        })
        .then(response => {
          // setando dados de paginação e a collection produtos
          this.paginated_data = response.data;
          this.campaign_products = this.paginated_data["products"];
        })
        .catch(error => this.setError(error, "Something went wrong"));
    },
    setStaticData(){
      this.$http.secured
        .get(`/api/v1/campaigns/${this.$route.params.campaign_id}`)
        .then(response => {
          this.campaign = response.data;
          this.setData();
        })
        .catch(error => this.setError(error, "failed to fetch branches"));

      this.$http.secured
        .get("/api/v1/products")
        .then(response => {
        // setando dados de paginação e a collection produtos
        // this.paginated_data = response.data;
        this.products = response.data["products"];
        })
        .catch(error => this.setError(error, "Something went wrong"));
    },
    changePage(page) {
      let filterInput = null;

      if (this.filtered) filterInput = this.filter;
      // Se algo foi pesquisado passa o parametro de filtro
      // Se não é passado parâmetro nulo
      this.setData(filterInput, page);
    },
    associate() {
      if (this.campaign_products.includes(this.product))
        return

      this.campaign_products.push(this.product)

      this.$http.secured
        .put("/api/v1/campaigns/" + this.campaign.id, { 
          campaign: { product_ids: this.campaign_products.map(e => e.id) }, 
          id: this.campaign.id })
        .then(response => {
          console.log("response: ",response.data)
          this.$toasted.global.defaultSuccess();
          // this.resetInputs()
        })
        .catch(error => {
          this.setError(error, "Cannot save Sector")
        });
    },
    desassociate(product) {
      this.campaign_products.splice(this.campaign_products.indexOf(product), 1)

      this.$http.secured
        .put("/api/v1/campaigns/" + this.campaign.id, {
          campaign: { product_ids: this.campaign_products.map(e => e.id),
          id: this.campaign.id } 
        })
        .then(response => {
          console.log("response: ",response.data)
          this.$toasted.global.defaultSuccess();
          // this.resetInputs()
        })
        .catch(error => {
          this.setError(error, "Cannot save Sector")
          this.$refs.observer.setErrors(this.errors)
        });
    },
    resetInputs() {
      this.filter = {}
      this.campaign = {}
    }
  },
  computed: {
    emptyFilter: function() {
      for (var key in this.filter) {
        if (
          this.filter.hasOwnProperty(key) &&
          this.filter[key] != "" &&
          typeof this.filter[key] != "undefined"
        ) {
          return false;
        }
      }
      return true;
    },
    normalizedFilter: function(){
      let filter = this.filter;
      for(let key in filter){
        // replacing objects by ids
        if (
          filter.hasOwnProperty(key) &&
          typeof filter[key] == 'object'
        ) {
          if(filter[key].hasOwnProperty('id')){
            filter[key + '_id'] = filter[key].id
            delete filter[key]
          } else {
            filter[key] = filter[key].value
          }
        }
        // removing empty fields
        if (filter[key] == "") {
          delete filter[key];
        }
      }

      return filter;
    },
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>

